/**
 * Slab Reader Service JavaScript
 * Only loaded on slab-reader pages
 */

document.addEventListener('DOMContentLoaded', () => {
    // Handle form submission
    const form = document.querySelector('#slabid-form');
    if (form) {
        form.addEventListener('submit', async function (e) {
            e.preventDefault();

            if (window.CreditUpsell && typeof window.CreditUpsell.preflightForm === 'function'
                && !(await window.CreditUpsell.preflightForm(form))) return;

            const submitBtn = form.querySelector('button[type="submit"]');
            const resultsSection = document.querySelector('#results-section');
            const resultsContainer = document.querySelector('#results-container');
            const placeholder = document.querySelector('#results-placeholder');
            const endpoint = form.dataset.endpoint || form.action;

            const originalText = submitBtn ? submitBtn.innerHTML : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.innerHTML = 'Analyzing...';
            }

            try {
                const formData = new FormData(form);
                const response = await fetch(endpoint, { method: 'POST', body: formData });
                const result = await response.json();
                console.log('API Response:', result);

                // Check for success in various response formats
                const isSuccess = result.success || result.records || (result.data && result.data.records);
                
                if (isSuccess) {
                    if (placeholder) placeholder.style.display = 'none';
                    if (resultsSection) resultsSection.style.display = 'block';
                    // Handle different response structures
                    const dataToUse = result.data || result;
                    displayResults(dataToUse, endpoint, resultsContainer);
                    resultsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                    if (response.status === 402 && window.CreditUpsell) {
                        window.CreditUpsell.show(result.credits_required || 1, result.credits_available || 0);
                    } else {
                        showAlert(result.error || 'Analysis failed', 'error');
                        if (response.status === 401 || response.status === 403) {
                            setTimeout(() => {
                                window.location.href = result.redirect || '/auth/register';
                            }, 1500);
                        }
                    }
                }
            } catch (err) {
                showAlert('Connection error: ' + err.message, 'error');
            } finally {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = originalText;
                }
            }
        });
    }
});

function displayResults(data, endpoint, container) {
    if (!container) return;
    console.log('Slab Reader API response:', data);

    const record = (data.records != null ? data.records[0] : void 0) || {};
    
    if (record.identification || record.slab || record.ocr) {
        container.innerHTML = XimilarResults.render('slab-id', record, data.original_image_url, data.credits_used, data.statistics, { action_id: data.action_id || null, share_url: data.share_url || null });
        return;
    }
    
    container.innerHTML = '<div style="padding: 20px; background: #f0f0f0;">Data received but no slab identification available</div>';
}

window.showAlert = window.showAlert || function showAlert(msg, type) {
    const div = document.createElement('div');
    const isError = type === 'error';
    div.className = 'pgc-alert pgc-alert-' + (isError ? 'error' : 'info');
    div.style.cssText = `position:fixed; bottom:30px; right:30px; max-width:420px; background:${isError ? '#fe2c55' : '#10b981'}; color:white; padding:18px 48px 18px 32px; border-radius:16px; z-index:999999; font-weight:700; font-size: 14px; line-height:1.5; box-shadow:0 15px 30px rgba(0,0,0,0.3); transform: translateY(0); transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);`;
    div.textContent = msg;

    // Close button (always present, but errors stay until dismissed)
    const closeBtn = document.createElement('span');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'position:absolute; top:10px; right:14px; font-size:22px; font-weight:300; cursor:pointer; opacity:0.8; line-height:1; padding:2px 4px;';
    closeBtn.onmouseover = () => closeBtn.style.opacity = '1';
    closeBtn.onmouseout = () => closeBtn.style.opacity = '0.8';
    closeBtn.onclick = () => {
        div.style.opacity = '0';
        div.style.transform = 'translateY(20px)';
        setTimeout(() => div.remove(), 400);
    };
    div.appendChild(closeBtn);

    document.body.appendChild(div);

    // Errors stay until dismissed; info toasts auto-dismiss (matches the
    // shared upload-handler version — "Converting iPhone photo" otherwise
    // floated over the whole flow until manually closed).
    if (!isError) {
        setTimeout(() => {
            div.style.opacity = '0';
            div.style.transform = 'translateY(20px)';
            setTimeout(() => div.remove(), 400);
        }, 6000);
    }
};
